// @flow
import React, { Component } from 'react';
import {
  TextArea, Checkbox, Radio, RadioGroup,
} from 'informed';

import { PrimaryText, SecondaryText } from '../../../Typography.jsx';
import ContentBox from '../../../ContentBox.jsx';

import styles from '../../../../styles/patientPages/progressNote/progressNote.scss';

type Props = {
  genitourinary: Object,
}

class ViewGenitourniary extends Component<Props> {
  render() {
    const genitourinary = this.props.genitourinary || {};
    return (
      <ContentBox title='Genitourinary'>
        <div className={styles.col}>
          <PrimaryText>Urinary System Assessment</PrimaryText><br />
          <div className={styles.section}>
            <SecondaryText>Urination mode:</SecondaryText><br />
            <RadioGroup field='genitourinary.voiding' initialValue={genitourinary.voiding}>
              <Radio disabled value='voiding' />Voiding<br />
              <Radio disabled value='foley cath' />Foley catheter to gravity drain<br />
              <Radio disabled value='straight cath self' />Straight catheter by self/family<br />
              <Radio disabled value='straight cath staff' />Straight catheter by staff<br />
              <Radio disabled value='diversion' />Urinary diversion<br />
              <Radio disabled value='anuric' />Anuric
            </RadioGroup>
          </div>
          <PrimaryText>Urine Color/Characteristics</PrimaryText><br />
          <div className={styles.section}>
            <SecondaryText>Color:</SecondaryText><br />
            <RadioGroup field='genitourinary.urineColor' initialValue={genitourinary.urineColor}>
              <Radio disabled value='yellow straw' />Yellow, straw-colored<br />
              <Radio disabled value='pale yellow' />Pale yellow<br />
              <Radio disabled value='dark yellow' />Dark yellow<br />
              <Radio disabled value='amber' />Amber<br />
              <Radio disabled value='dark brown' />Dark brown<br />
              <Radio disabled value='green-brown' />Green-brown<br />
              <Radio disabled value='orange-red' />Orange-red<br />
              <Radio disabled value='orange-brown' />Orange-brown<br />
              <Radio disabled value='red-brown' />Red-brown<br />
              <Radio disabled value='frank blood' />Frank blood
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Characteristics:</SecondaryText><br />
            <RadioGroup field='genitourinary.urineChars' initialValue={genitourinary.urineChars}>
              <Radio disabled value='clear' />Clear<br />
              <Radio disabled value='cloudy' />Cloudy<br />
              <Radio disabled value='precipitates' />Precipitates, sediment visible<br />
              <Radio disabled value='clots' />Clots visible<br />
              <Radio disabled value='milky' />Milky
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Odor:</SecondaryText><br />
            <RadioGroup field='genitourinary.odor' initialValue={genitourinary.odor}>
              <Radio disabled value='no odor' />No odor<br />
              <Radio disabled value='unusual' />Unusual odor<br />
              <Radio disabled value='foul' />Foul odor<br />
              <Radio disabled value='ammonia' />Ammonia odor<br />
              <Radio disabled value='sweet' />Sweet odor
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Urinary assessment:</SecondaryText><br />
            <Checkbox disabled field='genitourinary.noUrinaryProbs' initialValue={genitourinary.noUrinaryProbs} />No urinary problems noted
          </div>
          <div className={styles.section}>
            <SecondaryText>Mark all that apply:</SecondaryText><br />
            <Checkbox disabled field='genitourinary.noIncont' initialValue={genitourinary.noIncont} />No urinary incontinence<br />
            <Checkbox disabled field='genitourinary.occIncont' initialValue={genitourinary.occIncont} />Occasional incontinence<br />
            <Checkbox disabled field='genitourinary.stressIncont' initialValue={genitourinary.stressIncont} />Stress incontinence<br />
            <Checkbox disabled field='genitourinary.freqIncont' initialValue={genitourinary.freqIncont} />Frequent incontinence<br />
            <Checkbox disabled field='genitourinary.bladderDistent' initialValue={genitourinary.bladderDistent} />Bladder distention<br />
            <Checkbox disabled field='genitourinary.urineRetent' initialValue={genitourinary.urineRetent} />Urine retention<br />
            <Checkbox disabled field='genitourinary.painUrine' initialValue={genitourinary.painUrine} />Pain on urination<br />
            <Checkbox disabled field='genitourinary.burnUrine' initialValue={genitourinary.burnUrine} />Burning on urination<br />
            <Checkbox disabled field='genitourinary.urgency' initialValue={genitourinary.urgency} />Urgency<br />
            <Checkbox disabled field='genitourinary.freqUrine' initialValue={genitourinary.freqUrine} />Frequency<br />
            <Checkbox disabled field='genitourinary.hesitancy' initialValue={genitourinary.hesitancy} />Hesitancy<br />
            <Checkbox disabled field='genitourinary.dysuria' initialValue={genitourinary.dysuria} />Dysuria<br />
            <Checkbox disabled field='genitourinary.oliguria' initialValue={genitourinary.oliguria} />Oliguria<br />
            <Checkbox disabled field='genitourinary.nocturia' initialValue={genitourinary.nocturia} />Nocturia<br />
            <Checkbox disabled field='genitourinary.pyuria' initialValue={genitourinary.pyuria} />Pyuria
          </div>
          <div className={styles.section}>
            <SecondaryText>Urinary notes:</SecondaryText><br />
            <TextArea disabled field='genitourinary.urinaryNotes' initialValue={genitourinary.urinaryNotes} />
          </div>
          <PrimaryText>Dialysis</PrimaryText><br />
          <div className={styles.section}>
            <SecondaryText>Peritoneal dialysis:</SecondaryText><br />
            <Checkbox disabled field='genitourinary.peritoneal' initialValue={genitourinary.peritoneal} />Undergoing peritoneal dialysis<br />
            <Checkbox disabled field='genitourinary.renal' initialValue={genitourinary.renal} />Undergoing renal dialysis
          </div>
          <PrimaryText>Male</PrimaryText><br />
          <div className={styles.section}>
            <SecondaryText>Penis assessment:</SecondaryText><br />
            <Checkbox disabled field='genitourinary.noPenProbs' initialValue={genitourinary.noPenProbs} />No problems noted
          </div>
          <div className={styles.section}>
            <SecondaryText>Mark all that apply</SecondaryText><br />
            <Checkbox disabled field='genitourinary.penLesion' initialValue={genitourinary.penLesion} />Lesion (describe in Notes)<br />
            <Checkbox disabled field='genitourinary.penNodules' initialValue={genitourinary.penNodules} />Nodules (describe in Notes)<br />
            <Checkbox disabled field='genitourinary.penInflame' initialValue={genitourinary.penInflame} />Inflammation<br />
            <Checkbox disabled field='genitourinary.penRed' initialValue={genitourinary.penRed} />Redness<br />
            <Checkbox disabled field='genitourinary.penSwell' initialValue={genitourinary.penSwell} />Swelling<br />
            <Checkbox disabled field='genitourinary.penDischarge' initialValue={genitourinary.penDischarge} />Discharge (describe in Notes)<br />
            <Checkbox disabled field='genitourinary.penGenWarts' initialValue={genitourinary.penGenWarts} />Genital warts<br />
            <Checkbox disabled field='genitourinary.penCirc' initialValue={genitourinary.penCirc} />Circumcised<br />
            <Checkbox disabled field='genitourinary.penNotCirc' initialValue={genitourinary.penNotCirc} />Not circumcised<br />
            <Checkbox disabled field='genitourinary.penNoRetract' initialValue={genitourinary.penNoRetract} />Unable to retract foreskin<br />
            <Checkbox disabled field='genitourinary.penDisplaced' initialValue={genitourinary.penDisplaced} />Displaced meatus
          </div>
          <div className={styles.section}>
            <SecondaryText>Scrotum/testes assessment</SecondaryText><br />
            <Checkbox disabled field='genitourinary.noScrotProbs' initialValue={genitourinary.noScrotProbs} />No problems noted
          </div>
          <div className={styles.section}>
            <SecondaryText>Mark all that apply:</SecondaryText><br />
            <Checkbox disabled field='genitourinary.scrotLesion' initialValue={genitourinary.scrotLesion} />Lesion (describe in Notes)<br />
            <Checkbox disabled field='genitourinary.scrotNodules' initialValue={genitourinary.scrotNodules} />Nodules (describe in Notes)<br />
            <Checkbox disabled field='genitourinary.scrotInflame' initialValue={genitourinary.scrotInflame} />Inflammation, redness<br />
            <Checkbox disabled field='genitourinary.scrotEdema' initialValue={genitourinary.scrotEdema} />Edema<br />
            <Checkbox disabled field='genitourinary.scrotUndesc' initialValue={genitourinary.scrotUndesc} />One or both testicles undescended<br />
            <Checkbox disabled field='genitourinary.scrotDistVein' initialValue={genitourinary.scrotDistVein} />Distended veins<br />
            <Checkbox disabled field='genitourinary.scrotHydrocele' initialValue={genitourinary.scrotHydrocele} />Hydrocele<br />
            <Checkbox disabled field='genitourinary.scrotCystocele' initialValue={genitourinary.scrotCystocele} />Cystocele<br />
            <Checkbox disabled field='genitourinary.scrotLump' initialValue={genitourinary.scrotLump} />Lump/mass noted (descibe in Notes)<br />
            <Checkbox disabled field='genitourinary.scrotNits' initialValue={genitourinary.scrotNits} />Nits or parasites noted
          </div>
          <div className={styles.section}>
            <SecondaryText>Genitalia notes:</SecondaryText><br />
            <TextArea disabled field='genitourinary.genNotesMale' initialValue={genitourinary.genNotesMale} />
          </div>
          <PrimaryText>Female</PrimaryText><br />
          <div className={styles.section}>
            <SecondaryText>Female external genitalia assessment:</SecondaryText><br />
            <Checkbox disabled field='genitourinary.noFemProbs' initialValue={genitourinary.noFemProbs} />No problems noted
          </div>
          <div className={styles.section}>
            <SecondaryText>Mark all that apply</SecondaryText><br />
            <Checkbox disabled field='genitourinary.labLesions' initialValue={genitourinary.labLesions} />Labial lesions noted (describe in Notes)<br />
            <Checkbox disabled field='genitourinary.femNodules' initialValue={genitourinary.femNodules} />Nodules<br />
            <Checkbox disabled field='genitourinary.femInflame' initialValue={genitourinary.femInflame} />Inflammation<br />
            <Checkbox disabled field='genitourinary.femRed' initialValue={genitourinary.femRed} />Redness<br />
            <Checkbox disabled field='genitourinary.labSwell' initialValue={genitourinary.labSwell} />Labial swelling<br />
            <Checkbox disabled field='genitourinary.femChancres' initialValue={genitourinary.femChancres} />Chancres<br />
            <Checkbox disabled field='genitourinary.femPolyp' initialValue={genitourinary.femPolyp} />Polyp<br />
            <Checkbox disabled field='genitourinary.femGenWarts' initialValue={genitourinary.femGenWarts} />Genital warts<br />
            <Checkbox disabled field='genitourinary.femTrauma' initialValue={genitourinary.femTrauma} />Trauma noted<br />
            <Checkbox disabled field='genitourinary.femNits' initialValue={genitourinary.femNits} />Nits or parasites<br />
            <Checkbox disabled field='genitourinary.femDischargeBloody' initialValue={genitourinary.femDischargeBloody} />Vaginal discharge, bloody<br />
            <Checkbox disabled field='genitourinary.femDischargeWhite' initialValue={genitourinary.femDischargeWhite} />Vaginal discharge, white<br />
            <Checkbox disabled field='genitourinary.femDischargeCheesy' initialValue={genitourinary.femDischargeCheesy} />Vaginal discharge, cheesy<br />
            <Checkbox disabled field='genitourinary.femDischargeFoul' initialValue={genitourinary.femDischargeFoul} />Vaginal discharge, foul odor<br />
            <Checkbox disabled field='genitourinary.femDischargeGreen' initialValue={genitourinary.femDischargeGreen} />Vaginal discharge, green
          </div>
          <div className={styles.section}>
            <SecondaryText>Genitalia notes:</SecondaryText><br />
            <TextArea disabled field='genitourinary.genNotesFemale' initialValue={genitourinary.genNotesFemale} />
          </div>
        </div>
      </ContentBox>
    );
  }
}

export default ViewGenitourniary;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/progressNote/view/ViewGenitourinary.jsx